import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { useHistory, Link } from "react-router-dom";

const Register = () => {
  const { enqueueSnackbar } = useSnackbar();
  let [userName, setUserName] = useState("");
  let [password, setPassword] = useState("");
  let [confirmPassword, setConfirmPassword] = useState("");
  let [loader, setLoader] = useState(false);
  const history = useHistory();

  function stateSetter (event){
    if (event.target.id === `username`){
    setUserName(event.target.value);
    }
    if (event.target.id === `password`){
      setPassword(event.target.value);
    }
    if (event.target.id === `confirmPassword`){
      setConfirmPassword(event.target.value);
    }
  }
  // console.log(userName)
  // console.log(password)
  // console.log(confirmPassword)
  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function

  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  let formData = {username: userName, password: password, confirmPassword: confirmPassword};
  const register = async (formData) => {
    // console.log(formData);
    
    if(validateInput(formData)){
      setLoader(true);
    let objectToBePosted = {};
    objectToBePosted.username = formData.username;
    objectToBePosted.password = formData.password;
    
    await axios.post(`${config.endpoint}/auth/register`,objectToBePosted).then((response)=>{
      // console.log(response.data)
      if(response.data.success === true){
      // console.log("success reached")
      enqueueSnackbar(`Registered successfully`,{variant: `success`});
      setUserName("");
      setPassword("");
      setConfirmPassword("");
      history.push(`/login`);
      }
    }).catch((error)=>{
      if(error.response){
        enqueueSnackbar(`${error.response.data.message}`,{variant: `error`});
        setLoader(false);
      }else{
        enqueueSnackbar(`Something went wrong`,{variant: `error`});
        setLoader(false);
      }
    }).finally(()=>{
      setLoader(false);
    })
    }
  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    // console.log(data)
    if(data.username === "") {
      enqueueSnackbar(`Username is a required field`,{variant: `warning`});
      return false;
    }
    if((data.username).length < 6){
      enqueueSnackbar(`Username must be at least 6 characters`,{variant: `warning`});
      return false;
    }
    if(data.password === ""){
      enqueueSnackbar(`Password is a required field`,{variant: `warning`});
      return false;
    }
    if((data.password).length < 6){
      enqueueSnackbar(`Password must be at least 6 characters`,{variant: `warning`});
      return false;
    }
    if(data.password !== data.confirmPassword){
      enqueueSnackbar(`Passwords do not match`,{variant: `warning`});
      return false;
    }
    return true;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={1.2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            size="small"
            fullWidth
          onChange={(event)=>stateSetter(event)} value={userName}/>
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            size="small"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            onChange={(event)=>stateSetter(event)} value={password}/>
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            size="small"
            fullWidth
            onChange={(event)=>stateSetter(event)} value={confirmPassword}/>
           {!loader && <Button className="button" variant="contained" onClick={()=>register(formData)}>
            Register Now
           </Button>}
           {loader && <div id="cp"><CircularProgress/></div>}
          <Link to="/login"><p className="secondary-action">
            Already have an account?{" "}
             <span className="link">
              Login here
             </span>
          </p></Link>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
